import { Schoolyear, SchoolyearApi } from '@teetsh/app/src/types/schoolyear';
import {
  deserializeZone,
  serializeZone,
} from '@teetsh/app/src/queries/zoneInfos/serializer';
import deserializeDateFromServer from '@teetsh/app/src/utils/time/deserializeDateFromServer';
import parseISO from '@teetsh/app/src/utils/time/parseISO';

export function deserializeSchoolyear(
  schoolyear: SchoolyearApi,
  tz: string,
): Schoolyear {
  return {
    ...schoolyear,
    label: schoolyear.label || `${schoolyear.year - 1} - ${schoolyear.year}`,
    zone: deserializeZone(tz, schoolyear.zone),
    minDate: schoolyear.minDate
      ? deserializeDateFromServer(parseISO(schoolyear.minDate), tz)
      : undefined,
    maxDate: schoolyear.maxDate
      ? deserializeDateFromServer(parseISO(schoolyear.maxDate), tz)
      : undefined,
  };
}

export function serializeSchoolyear(
  { label, ...schoolyear }: Schoolyear,
  tz: string,
): SchoolyearApi {
  const { minDate, maxDate, ...schoolyearWithoutMinMax } = schoolyear;
  return {
    ...schoolyearWithoutMinMax,
    zone: serializeZone(schoolyear?.zone, tz),
  };
}
